import { gql } from './__generated__';

export const CREATE_CHECKOUT_LINK = gql(/* GraphQL */ `
  mutation createCheckoutLink($input: CreateCheckoutLinkInput!) {
    checkout {
      createLink(input: $input)
    }
  }
`);
